import i18n from '../../i18n/i18n';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  INotificationItem,
  INotificationListResponse,
  NotificationThunkError,
} from '../../interface/notification-log.interface';
import { fetchNotifications, markNotificationsAsRead } from '../action/notification-log.action';

interface NotificationLogState {
  notifications: INotificationItem[];
  total: number;
  totalUnread: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  error: NotificationThunkError | null;
}

const initialState: NotificationLogState = {
  notifications: [],
  total: 0,
  totalUnread: 0,
  page: 0,
  pageSize: 10,
  isLoading: false,
  error: null,
};

const notificationLogSlice = createSlice({
  name: 'notificationLog',
  initialState,
  reducers: {
    resetNotificationLogState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        fetchNotifications.fulfilled,
        (state, action: PayloadAction<INotificationListResponse>) => {
          state.isLoading = false;
          state.notifications = action.payload.notifications;
          state.total = action.payload.total;
          state.totalUnread = action.payload.totalUnread;
          state.page = action.payload.page ?? 0;
          state.pageSize = action.payload.pageSize ?? 10;
        },
      )
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: i18n.t('msg.failed_to_fetch_notifications', 'Failed to fetch notifications'),
        };
      })
      .addCase(markNotificationsAsRead.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(markNotificationsAsRead.fulfilled, (state, _action) => {
        state.isLoading = false;
        // After marking as read, refetch notifications in component
      })
      .addCase(markNotificationsAsRead.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: i18n.t(
            'msg.failed_to_mark_notifications_as_read',
            'Failed to mark notifications as read',
          ),
        };
      });
  },
});

export const { resetNotificationLogState } = notificationLogSlice.actions;
export default notificationLogSlice.reducer;
